import "../../../../FhTableRow.css";
import { openBlock, createElementBlock, renderSlot, normalizeClass } from "vue";
import { _ as _export_sfc } from "../../../../_plugin-vue_export-helper-1tPrXgE0.js";
const _sfc_main = {};
const _hoisted_1 = {
  class: /* @__PURE__ */ normalizeClass("fh-table-row")
};
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("tr", _hoisted_1, [
    renderSlot(_ctx.$slots, "default", {}, void 0, true)
  ]);
}
const FhTableRow = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-1b24b25a"]]);
export {
  FhTableRow as default
};
//# sourceMappingURL=FhTableRow.mjs.map
